import { useNavigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '../../redux/hooks';
import { selectUserFullName } from '../../redux/reducers/userSelectors';
import { ISideBarItems } from './model';

// assets.
import logoPortalZones from '../../static/assets/icons/logo-portal-zonas.svg';
import hand from '../../static/assets/icons/hand.svg';
import handGray from '../../static/assets/icons/handGray.svg';
import homePin from '../../static/assets/icons/home_pin.svg';
import pinHome from '../../static/assets/icons/pinehome.svg';
import checkHouse from '../../static/assets/icons/CheckHouse.svg';
import houseCheck from '../../static/assets/icons/houseCheck.svg';
import HesH from '../../assets/icons/HesH.svg';
import HesHGray from '../../assets/icons/HesH-gray.svg';
import Quotas from '../../assets/icons/QuotasLogo.svg';
import QuotasGray from '../../assets/icons/QuotasLogoGray.svg';
import approvalRulesIcon from '../../assets/icons/approval-rules-icon.svg';
import approvalRulesIconGray from '../../assets/icons/approval-rules-icon-gray.svg';
import house_Check from '../../assets/images/house_Check.svg';
import house_check_purple from '../../assets/images/house_check_purple.svg';
import task from '../../static/assets/icons/task.svg';
import taskCheck from '../../static/assets/icons/task-purple.svg';

// Styles
import { SidebarWrapper } from '../Layout/style';

const LayoutSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userFullName = useAppSelector(selectUserFullName);
  const zoneState = useAppSelector(state => state.zoneStore);

  const handleRedirect = (url: string) => {
    navigate(url);
  };

  const rol = localStorage.getItem('ROL');

  const sidebarItemsApprover = [
    {
      id: 7,
      name: 'Aprobaciones',
      url: '/aprobologo',
      image_Selected: house_check_purple,
      image: house_Check,
      selected: false,
    },
    {
      id: 8,
      name: 'Tareas',
      url: '/tareas-aprobologo',
      image_Selected: taskCheck,
      image: task,
      selected: false,
    },
    {
      id: 9,
      name: 'Visualizador',
      url: '/visualizador-manual',
      image_Selected: homePin,
      image: homePin,
      selected: false,
    },
  ];

  const sidebarItemsComercial = [
    {
      id: 1,
      name: 'Aprobaciones',
      url: '/aprobologo',
      image_Selected: house_check_purple,
      image: house_Check,
      selected: false,
    },
    {
      id: 9,
      name: 'Visualizador',
      url: '/visualizador-manual',
      image_Selected: homePin,
      image: homePin,
      selected: false,
    },
  ];

  const sidebarItemsGuru = [
    {
      id: 1,
      name: 'Análisis de zona',
      url: zoneState.zone ? '/portal/analisis-de-zona' : '/seleccion-de-zona',
      image_Selected: pinHome,
      image: homePin,
      selected: false,
    },
    {
      id: 2,
      name: 'Motor de descuentos',
      url: '/motor-de-descuento',
      image_Selected: hand,
      image: handGray,
      selected: false,
    },
    {
      id: 3,
      name: 'Validaciones de zona ',
      url: '/validacion-de-zona',
      image_Selected: checkHouse,
      image: houseCheck,
      selected: false,
    },
    {
      id: 4,
      name: 'HesH',
      url: '/habi-es-habi',
      image_Selected: HesH,
      image: HesHGray,
      selected: false,
    },
    {
      id: 5,
      name: 'Lógica de cupos',
      url: '/logica-de-cupos',
      image_Selected: Quotas,
      image: QuotasGray,
      selected: false,
    },
    {
      id: 6,
      name: 'Reglas de aprobación',
      url: '/reglas-aprobacion',
      image_Selected: approvalRulesIcon,
      image: approvalRulesIconGray,
      selected: false,
    },
    {
      id: 7,
      name: 'Aprobaciones',
      url: '/aprobologo',
      image_Selected: house_check_purple,
      image: house_Check,
      selected: false,
    },
    {
      id: 8,
      name: 'Tareas',
      url: '/tareas-aprobologo',
      image_Selected: taskCheck,
      image: task,
      selected: false,
    },
    {
      id: 9,
      name: 'Visualizador',
      url: '/visualizador-manual',
      image_Selected: homePin,
      image: homePin,
      selected: false,
    },
  ];
  const getSidebarItems = (role: string | null) => {
    if (!role) return [];
    if (role.includes('equipo_bo')) return sidebarItemsGuru;
    if (role.includes('comercial')) return sidebarItemsComercial;
    return sidebarItemsApprover;
  };

  const sidebarItems = getSidebarItems(rol);

  const handleShowRolName = () => {
    if (rol?.includes('equipo_bo')) {
      return 'GURÚ DE ZONA';
    }
    if (rol?.includes('comercial')) {
      return 'COMERCIAL';
    }

    return 'APROBÓLOGO';
  };

  return (
    <SidebarWrapper>
      <div className="sidebar-container">
        <img src={logoPortalZones} alt="logo portal zonas" />
        <div className="user-information flex column">
          <span className="user-info">{userFullName}</span>
          <span className="role-user">{handleShowRolName()}</span>
          <div className="separator-gray" />
          {sidebarItems.map((item: ISideBarItems) => (
            <div
              key={item.id}
              role="button"
              className={
                item.url === location.pathname
                  ? 'sidebar-button-selected '
                  : 'sidebar-button-clean'
              }
              tabIndex={0}
              onClick={() => handleRedirect(item.url)}
              onKeyDown={ev => ev.key === 'Enter' && handleRedirect(item.url)}
            >
              <img
                src={
                  item.url === location.pathname
                    ? item.image_Selected
                    : item.image
                }
                className="mr-5"
                alt="icono"
              />
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </SidebarWrapper>
  );
};

export default LayoutSidebar;
